module.exports = __webpack_public_path__ + "static/media/end_slide-2.29b4c15c.svg";